import React, { FC } from 'react'
import { breakpointDown, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Grid, Box } from '@moonpig/launchpad-components'
import {
  ModuleSimplifiedTwoColumnProductHeading,
  Module,
  ModuleContext,
} from '../../types'

type Props = {
  module: ModuleSimplifiedTwoColumnProductHeading
  context: ModuleContext
  map: (module: Module, props: ModuleContext) => React.JSX.Element | null
}

const StyledColumnLeft = styled(Box)`
  width: 50%;
  ${s({
    p: 0,
    m: 0,
    mb: 8,
    pl: '6%',
  })}
  ${breakpointDown('md')} {
    ${s({
      pl: 6,
      mb: 4,
    })}
  }
  ${breakpointDown('sm')} {
    width: 100%;
    ${s({
      mb: 0,
    })}
  }
`

const StyledColumnRight = styled(Box)`
  width: 50%;
  ${s({
    p: 0,
    m: 0,
  })}
  ${breakpointDown('sm')} {
    width: 100%;
    ${s({
      pl: 6,
      mb: 0,
    })}
  }
`

export const SimplifiedTwoColumnProductHeadingModule: FC<Props> = ({
  module: { left, right },
  context,
  map,
}) => {
  return (
    <Grid
      data-testid="module-simplified-two-column-product-heading"
      gap
      p={0}
      m={0}
    >
      <StyledColumnLeft>
        {left.map((m, key) => map(m, { ...context, key }))}
      </StyledColumnLeft>
      <StyledColumnRight>
        {right.map((m, key) => map(m, { ...context, key }))}
      </StyledColumnRight>
    </Grid>
  )
}
